const ensureMeta = (selector, attributes) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value) node.setAttribute(key, value);
  });
  return node;
};

export const setBlogMeta = ({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  type = "website",
}) => {
  if (title) document.title = title;

  ensureMeta('meta[name="description"]', { name: "description", content: description || "" });
  ensureMeta('meta[property="og:type"]', { property: "og:type", content: type });
  ensureMeta('meta[property="og:title"]', { property: "og:title", content: ogTitle || title || "" });
  ensureMeta('meta[property="og:description"]', {
    property: "og:description",
    content: ogDescription || description || "",
  });

  if (ogImage) {
    ensureMeta('meta[property="og:image"]', { property: "og:image", content: ogImage });
  }

  if (canonical) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
    ensureMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
  }
};
